import styled from "styled-components";
import { Button, MediaQueries } from "ratel-ui";

export const Content = styled.div`
  z-index: 100;
  width: 100%;
  max-width: 1172px;
  margin: 32px auto 0;
  padding: 0 16px 16px;

  @media (max-width: 767px) {
    margin-top: 24px;
    padding: 0 16px 16px;
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  font-size: 1.125rem;
  font-weight: bold;

  ${MediaQueries.mobile`
    font-size: 0.875rem;
  `}
`;

export const Left = styled.span`
  margin: 0 0 8px 16px;
  color: #000;
`;

export const Right = styled.span`
  padding: 0px 16px 8px 0;
  color: ${(props) => props.theme.colors.font2};
  fill: ${(props) => props.theme.colors.font2};
  font-size: 1rem;
  border-radius: 24px;
  cursor: pointer;

  > svg {
    margin-right: 8px;
  }
`;

export const FooterLeft = styled.div`
  display: flex;
  align-items: center;
  font-size: 1rem;
  font-weight: 700;

  ${MediaQueries.mobile`
    display: flex;
    text-align: left;
    align-items: flex-start;
    justify-content: flex-start;
    flex-direction: column;
  `}
`;

export const FooterRight = styled.div`
  display: flex;
`;

export const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 16px 32px 0 0;
  font-size: 10px;

  ${MediaQueries.mobile`
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    flex-direction: column-reverse;
    padding: 16px 0 0 8px;
  `}
`;

export const Corrects = styled.div`
  display: flex;
  align-items: center;
  color: ${(props) => props.theme.colors.font4};

  svg {
    margin-right: 8px;
    fill: ${(props) => props.theme.colors.success};
  }
`;

export const Incorrects = styled.div`
  display: flex;
  align-items: center;
  padding-left: 16px;
  font-size: 10px;
  color: ${(props) => props.theme.colors.font4};

  svg {
    margin-right: 8px;
    fill: ${(props) => props.theme.colors.error};
  }
`;

export const Grid = styled.div`
  border-radius: 16px;
  overflow: hidden;
  border: 1px solid #1B229F;
`;

export const Table = styled.table`
  width: 100%;
  margin: 0;
  padding: 0;
  table-layout: fixed;
`;

export const Thead = styled.thead`
  background-color: ${(props) => props.theme.colors.transparent};
`;

export const Tr = styled.tr`
  margin: 0;
  text-align: left;
  background-color: ${(props) => props.theme.colors.transparent};
  border-bottom: none;

  ${({ isLast }) =>
    isLast &&
    `
    border-bottom: none;
  `};

  ${MediaQueries.mobileTablet`
    text-align: center;
  `}
`;

export const Th = styled.th`
  padding: 8px;
  text-align: center;
  font-size: 0.875rem;
  letter-spacing: 0.1em;
  vertical-align: middle;
  color: #1B229F;
  
  &:last-child {
    border-left: 1px solid #1B229F;
    color: #1B229F;
  }

  ${MediaQueries.mobile`
    font-size: 0.75rem;
  `}

  ${({ resolution }) =>
    resolution &&
    `
      color: #000;
      padding: 27px;

      ${MediaQueries.mobile`
        padding: 8px;
      `}

      ${MediaQueries.desktop`
        padding: 16px;
      `}
  `};

  ${({ question }) =>
    question &&
    `
      padding-left: 8px;

      ${MediaQueries.mobile`
        padding-left: 16px;
      `}

      ${MediaQueries.desktop`
        text-align: left;
      `}
  `};

  ${({ small }) =>
    small &&
    `
      font-weight: 600;
  `};
`;

export const Td = styled.td`
  padding: 16px;
  text-align: ${(props) => (props.question ? "left" : "center")};
  font-size: 0.875rem;
  font-weight: ${(props) => (props.bold ? 700 : 400)};
  color: ${(props) =>
    props.questionCanceled ? props.theme.colors.font5 : "#000"};
  ${(props) =>
    props.questionCanceled &&
    `
    text-decoration: line-through;
  `};
  vertical-align: middle;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  border-bottom: 1px solid #1B229F;

  svg {
    fill: ${(props) =>
      props.correct ? props.theme.colors.success : props.theme.colors.error};
  }

  &:last-child {
    padding: 8px;
    border-left: 1px solid #265bf1;
  }

  ${MediaQueries.mobileTablet`
    padding: 8px;
    justify-content: center;
  `}
`;

export const IconVideo = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  margin: auto;
  border-radius: 50%;
  background: ${(props) => props.theme.colors.bg1};
  border: 1px solid ${(props) => props.theme.colors.clear};

  ${MediaQueries.mobile`
    min-height: 24px;
    min-width: 24px;
    max-height: 24px;
    max-width: 24px;
  `}

  svg {
    fill: ${(props) => props.theme.colors.clear};

    ${MediaQueries.mobile`
      width: 12px;
      height: 12px;
    `}
  }
`;

export const DownloadPDF = styled.a`
  margin-right: 16px;
  fill: ${(props) => props.theme.colors.bg1};
  color: ${(props) => props.theme.colors.bg1};
  cursor: pointer;

  svg {
    margin-right: 8px;
  }
`;

export const QuestionText = styled.span`
  text-overflow: ellipsis;
  vertical-align: middle;
  white-space: nowrap;
  overflow: hidden;
  text-align: left;
  ${(props) =>
    props.questionCanceled &&
    `
    text-decoration: line-through;
  `};
  color: #000;
`;

export const NumberQuestion = styled.span`
  display: inline-block;
  width: 24px;
  height: 24px;
  margin-right: 8px;
  padding-top: 3px;
  border-radius: 50%;
  font-size: 0.75rem;
  font-weight: 700;
  text-align: center;
  color: ${(props) =>
    props.questionCanceled ? props.theme.colors.font5 : "#1B229F"};
  border: 2px solid
    ${(props) =>
      props.questionCanceled ? props.theme.colors.font5 : "#1B229F"};
`;

export const BadgeCanceled = styled.span`
  display: inline-block;
  text-align: center;
  border-radius: 8px;
  font-size: 10px;
  padding: 1px 8px;
  margin-right: 8px;
  color: ${(props) => props.theme.colors.font1};
  background: #ffb908;
`;

export const Tbody = styled.tbody``;

export const MyAnswerDownload = styled.div`
  padding: 8px 0;
  color: ${(props) => props.theme.colors.font2};
  fill: ${(props) => props.theme.colors.font2};
  text-align: right;
  font-size: 1rem;
  font-weight: 700;
  cursor: pointer;
  margin-left: 16px;
  margin-right: 24px;

  svg {
    margin-right: 8px;
    fill: ${(props) => props.theme.colors.font2};
  }

  ${MediaQueries.mobile`
    margin-left: 0;
  `}

  ${MediaQueries.mobileSmall`
    margin-top: 8px;
  `}
`;

export const Buttons = styled(Button)`
  color: #1B229F;
  border: 1px solid #1B229F;
  background: transparent;
  z-index: 400;

  @media (max-width: 767px) {
    font-size: 0.75rem;
    padding: 0 20px;
    height: 29px;
  }
`;

export const FooterButtons = styled.div`
  margin-top: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 1.1rem;
`;

export const Span = styled.span`
  margin: 78px 0 8px;
  color: ${props => props.theme.colors.font5};
  font-family: "Rubik", sans-serif;
  font-size: 0.75rem;
  text-align: center;
  strong {
    font-weight: 700;
    color: ${props => props.theme.colors.font5};
  }
`;

export const ButtonLink = styled.a`
  align-items: center;
  border-radius: 32px;
  color: #000;
  cursor: pointer;
  display: flex;
  font-size: 0.875rem;
  height: 32px;
  justify-content: center;
  padding: 12px 20px;
  transition: all 0.6s ease;
  text-align: center;
  font-size: 0.9375rem;
  font-weight: 600;

  :nth-child(2) {
    background: #1B229F;
    width: 325px;
    height: 46px;
    color: #fff;
    font-size: 1rem;
    font-weight: 700;

    :hover {
      color: #1B229F;
      background: transparent;
    }
  }

  :last-child {
    background: #FF5227;
    font-size: 15px;
  }

  svg {
    margin-left: 18px;
    fill: #ed2929;
  }

  :hover {
    color: #fff;
    background: #ed2929;
    svg {
      transition: all 1s ease;
      fill: #fff;
    }
  }
`;

export const BannerBg = styled.div`
  width: 100%;
  background: #000000;
  display: flex;
  align-items: center;
  justify-content: center;

`;


export const Banner = styled.img`
  margin: 24px 0 16px;


  @media (max-width: 767px) {
    margin-top: 40px 0 16px;
  }
`;

export const CertificateCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 600px;
  margin: 32px auto 40px;
  padding: 20px 32px;
  background: linear-gradient(135deg, #265BF1 0%, #1B229F 100%);
  border-radius: 16px;
  box-shadow: 0px 8px 16px rgba(38, 91, 241, 0.3);
  text-align: center;

  ${MediaQueries.mobile`
    padding: 16px;
    margin: 24px 16px 32px;
  `}

  ${({ disabled }) =>
    disabled &&
    `
    background: linear-gradient(135deg, #E8E8E8 0%, #D0D0D0 100%);
    box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.1);
  `}
`;

export const CertificateTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-bottom: 8px;

  ${MediaQueries.mobile`
    gap: 8px;
  `}
`;

export const CertificateEmoji = styled.span`
  font-size: 2rem;
  line-height: 1;

  ${MediaQueries.mobile`
    font-size: 1.5rem;
  `}
`;

export const CertificateTitle = styled.h3`
  font-family: "Rubik", sans-serif;
  font-size: 1.5rem;
  font-weight: 700;
  color: #FFFFFF;
  margin: 0 0 8px 0;
  line-height: 1.3;

  ${MediaQueries.mobile`
    font-size: 1.25rem;
  `}

  ${({ disabled }) =>
    disabled &&
    `
    color: #999999;
  `}
`;

export const CertificateSubtitle = styled.p`
  font-family: "Nunito", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.9);
  margin: 0 0 20px 0;
  line-height: 1.5;

  ${MediaQueries.mobile`
    font-size: 0.875rem;
    margin: 0 0 16px 0;
  `}

  ${({ disabled }) =>
    disabled &&
    `
    color: #777777;
  `}
`;

export const CertificateButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 14px 32px;
  background: #FFFFFF;
  border: none;
  border-radius: 30px;
  color: #265BF1;
  font-family: "Nunito", sans-serif;
  font-size: 1rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.15);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0px 6px 12px rgba(0, 0, 0, 0.2);
  }

  &:active {
    transform: translateY(0);
  }

  &:disabled {
    background: #E0E0E0;
    color: #999999;
    cursor: not-allowed;

    &:hover {
      transform: none;
      box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.15);
    }
  }

  ${MediaQueries.mobile`
    font-size: 0.875rem;
    padding: 12px 24px;
  `}
`;
